import api from "../utils/api";
import getSiteInfo from "../utils/getSiteInfo";

export const createLeads = async (lang, email, countryCode, contractId) => {
  try {
    const siteInfo = await getSiteInfo(lang);
    return api.leads.create(null, {
      emailAddress: email,
      country: countryCode,
      preferredLanguage: siteInfo.preferredLanguage,
      contractId
    });
  } catch (ex) {
    console.error("create leads failed...");
  }
};
